<template>
  <p class="info-tit">
    <slot></slot>
  </p>
</template>

<script>
// 信息组件
export default {
  name:'InfoTit'
}
</script>

<style lang='less' scoped>
.info-tit{
    position: relative;
    display: block;
    height:38px;
    line-height:38px;
    padding-left:40px;
    color: #505d6e;
    font-size: 14px;
    font-weight: 500;
    border-bottom: 1px solid #edeff2;
    &::before{
      position: absolute;
      content: '';
      top:12px;
      left:16px;
      width: 17px;
      height: 16px;
      background: url('../../assets/images/icon_cube.png') center top/cover no-repeat;
    }
  }
</style>